import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/InventoryListPage.css';
import { FaEye, FaEdit } from 'react-icons/fa';

const StockListPage = () => {
    const [inventories, setInventories] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); 
        }
    }, [currentPage, isSearched]);

    const handleSearch = async () => {
        try {
            const response = await api.post('/inventory/getInventoryList', {
                data: [{
                    item_name: searchName,
                    item_type: selectedType,
                }],
                limit: 25, 
                page: currentPage 
            });
            setInventories(response.data.data.inventoryList);
            setTotalData(response.data.data.totalCount); 
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); 

            const totalCount = response.data.data.totalCount;
            
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / 25));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch inventories", error);
        }
    };
    

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleViewDetails = (inventoryId) => {
        navigate(`/inventory/detail/${inventoryId}`);
    };

    const handleEditDetails = (inventoryId) => {
        navigate(`/edit-inventory/${inventoryId}`);
    };

    const formatNumber = (number) => {
        return Number(number).toLocaleString('id-ID', { maximumFractionDigits: 0 });
    };

    return (
        <div className="inventory-page">
            <div className="page-title">Stock List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter item name"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Type</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedType}
                                            onChange={(e) => setSelectedType(e.target.value)}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="BOOK">BOOK</option>
                                            <option value="OTHERS">OTHERS</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Item Name</th>
                                    <th>Item Type</th>
                                    <th>Central Stock</th>
                                    <th>Branch Stock</th>
                                    <th>Price</th>
                                    <th>Program</th>
                                    <th>Program Level</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inventories.map((inventory, index) => (
                                    <tr key={inventory.inventory_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                        <td>{inventory.item_name}</td>
                                        <td>{inventory.item_type}</td>
                                        <td>{inventory.central_stock}</td>
                                        <td>{inventory.branch_stock}</td>
                                        <td>{formatNumber(inventory.price)}</td>
                                        <td>{inventory.Program ? inventory.Program.program_name : "All Programs"}</td>
                                        <td>{inventory.Level ? inventory.Level.level_name : "All Programs"}</td>
                                        <td>
                                            <FaEye className="action-icon" title="View Details" onClick={() => handleViewDetails(inventory.inventory_id)} />
                                            <FaEdit className="action-icon" title="Edit Inventory" onClick={() => handleEditDetails(inventory.inventory_id)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                </div>
                <div className="pagination">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                        Prev
                                    </button>
                                </td>
                                <td>
                                    <span>Page {currentPage} of {totalPages}</span>
                                </td>
                                <td>
                                    <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                        Next
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default StockListPage;
